import styled from 'styled-components';
import { v2Colors, v2FontFamily } from '../formInputsV2/styles/tokens';

export const HeaderStyles = styled.div`
  .page-nav {
    padding: 12px 30px;
    background: #fff;
    box-shadow: 0 1px 0 #eef1f4, 0 2px 12px rgba(16, 24, 40, 0.04);
  }

  /* "Greenia AI" trigger — kept as a dark pill with the Lottie sparkle
     untouched, just refined to the v2 radius/font and given a soft green
     glow (its accent color) instead of Bootstrap's flat .btn-dark defaults. */
  .search-box button {
    border-radius: 10px;
    padding: 8px 16px;
    border: none;
    box-shadow: 0 2px 10px rgba(0, 166, 81, 0.25);
    transition: box-shadow 150ms ease, transform 150ms ease;
  }

  .search-box button p {
    font-family: ${v2FontFamily};
    font-size: 13.5px;
  }

  .search-box button:hover {
    box-shadow: 0 4px 14px rgba(0, 166, 81, 0.35);
    transform: translateY(-1px);
  }

  .user-info {
    padding: 0 14px;
    font-family: ${v2FontFamily};
    line-height: 1.3;
  }

  .user-info .email {
    font-size: 11.5px;
    color: ${v2Colors.textMuted};
  }

  .user-info h6 {
    font-size: 13.5px;
    color: ${v2Colors.text};
  }

  .avatar {
    width: 40px;
    height: 40px;
    overflow: hidden;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .avatar img {
    height: 100%;
    width: auto;
  }

  .logout {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border: none;
    border-radius: 8px;
    background: transparent;
    margin-left: 6px;
    padding: 0;
    color: ${v2Colors.textMuted};
    cursor: pointer;
    transition: background-color 150ms ease, color 150ms ease;

    svg {
      width: 16px;
      height: 16px;
    }

    &:hover {
      background: ${v2Colors.dangerSoft};
      color: ${v2Colors.danger};
    }
  }

  .menu {
    font-size: 1.2em;
    border: none;
    background: transparent;
    color: ${v2Colors.textMuted};
    cursor: pointer;
    width: 34px;
    height: 34px;
    border-radius: 8px;
    transition: background-color 150ms ease;

    &:hover {
      background: ${v2Colors.disabledSurface};
    }
  }
`;
